import {
  getSingularLabel,
  toFieldOption,
  getFilterBindingSources,
  getConditionalVisibilityBindingSources,
} from '@packages/systems/dynamo/utils/ParamPanelUtils';
import {createFieldPath} from '@packages/systems/dynamo/utils/ParamFieldPathUtils';

import type {ConsolidatedBindingContext} from '@packages/systems/dynamo/gateway';

import type {ParamPanelProps, ParamPanelUIProps} from './types';

type FieldOptions = ParamPanelUIProps['availableFieldOptions'];

export function getFieldOptions(
  type: ParamPanelProps['type'],
  bindingContext: ConsolidatedBindingContext,
  parentBindingContext: ConsolidatedBindingContext | null
): FieldOptions {
  const groups: Map<string, FieldOptions> = new Map();
  // We are setting the key for group without the heading as first
  // so that the group appears at first in the options.
  groups.set('', []);

  const sources =
    type === 'query'
      ? getFilterBindingSources(bindingContext)
      : getConditionalVisibilityBindingSources(bindingContext);

  sources.forEach((source) => {
    const fieldOption = {...toFieldOption(source), kind: 'option'} as const;

    const groupLabel = source.groupLabel || '';
    const group = groups.get(groupLabel) || [];

    group.push(fieldOption);

    groups.set(groupLabel, group);
  });

  const fieldOptions: FieldOptions = [];

  groups.forEach((group: FieldOptions, groupLabel: string) => {
    if (groupLabel) {
      fieldOptions.push({kind: 'heading', label: groupLabel});
    }

    fieldOptions.push(...group);
  });

  if (parentBindingContext && bindingContext.matches(parentBindingContext)) {
    const fakeIdFieldOption = {
      kind: 'option',
      name: getSingularLabel(bindingContext) || 'Collection',
      type: 'Id',
      humanizedType: null,
      value: createFieldPath('_id'),
      nested: false,
    } as const;

    // add faked id field for DYN_CONTEXT "Current Item is/is not Context Item"
    return [fakeIdFieldOption, ...fieldOptions];
  }

  return fieldOptions;
}
